import { queryRequest } from "@/utils/request";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { RootState } from "../..";
import { wtSpeedWorkCreateOrder } from "@/graphql/order.gql";
import { GTGroupActivityParam } from "@/enums/app";

export interface IPromotionConfirmState {
  allData: any[];
  amount: string;
  storeInfo: any;
}

@Module({ name: "PromotionConfirmModule", namespaced: true })
export default class PromotionConfirmModule
  extends VuexModule<IPromotionConfirmState, RootState>
  implements IPromotionConfirmState {
  public allData: any[] = [];
  public amount: string = "";
  public storeInfo: any = {};

  @Mutation
  saveAllData(data) {
    this.allData = data || [];
  }

  @Mutation
  saveAmount(data = "") {
    this.amount = data;
  }
  @Mutation
  saveStoreInfoMutation(data: any) {
    this.storeInfo = data || {};
  }

  @Action
  async submitOrderAction({ activityCode = "" } = {}) {
    const {
      state: { allData, storeInfo }
    } = this.context;
    const { wtSpeedWorkCreateOrder: orderCode } = await queryRequest(
      {
        query: wtSpeedWorkCreateOrder,
        variables: {
          input: {
            storeInputs: [
              {
                isExpress: 0,
                orgCode: storeInfo.orgCode,
                storeCode: storeInfo.storeCode,
                productInputs: allData.map(
                  ({ skuCode, productCode, sellPrice, count }) => ({
                    count,
                    skuCode,
                    productCode,
                    // oldSellPrice: sellPrice,
                    priceActivityCode: activityCode
                  })
                )
              }
            ],
            payMentType: +storeInfo.amount === 0 ? "offline" : "online", // 0元下单默认线下,
            terminal: "51",
            ...GTGroupActivityParam
          }
        }
      },
      { custom: true }
    );

    return orderCode;
  }
}
